import axios from "axios"
import { newPessoa } from "../db/Orm"
import { formatarCelular } from "../utils/strings"
enum DAYS {
    ONE = 1,
    TWO = 2,
    THREE = 3,
    FOUR = 4,
    FIVE = 5,
    SIX = 6,
}
const cnpj = async (cnpj: string) => {
    const pessoa = newPessoa()
    const data = (await axios.get(`https://brasilapi.com.br/api/cnpj/v1/${cnpj.replaceAll('.', '').replaceAll('/', '').replaceAll('-', '')}`)).data
    if (data.erro) {
        console.log("CNPJ não encontrado", data.erro)

    } else {
        pessoa.cpf_cnpj = data.cnpj
        pessoa.nome_razao = data.razao_social
        pessoa.email = data.email || ''
        pessoa.celular = formatarCelular(data.ddd_telefone_1) || ''
        pessoa.cep = data.cep
        pessoa.endereco = data.logradouro
        pessoa.numero = data.numero
        pessoa.bairro = data.bairro
        pessoa.cidade = data.municipio
        pessoa.uf = data.uf
        return pessoa
    }
    return null
}
const cod = async (municipio: any) => {
    const data = (await axios.get(`https://brasilapi.com.br/api/cptec/v1/cidade/${municipio.nome}`)).data
    if (data.erro) {
        console.log("Município não encontrado", data.erro)
    } else {
        console.log("Municipality code found:", data);
        return (data as Array<any>).find((m: any) => m.estado === global.uf)?.id || null
    }
    return null
}
const prev = async (municipio: number, days?: DAYS) => {
    const data = (await axios.get(`https://brasilapi.com.br/api/cptec/v1/clima/previsao/${municipio}/${days}`)).data
    if (data.erro) {
        console.log("Previsão não encontrada", data.erro)
    } else {
        console.log("Previsão encontrada:", data);
        return data
    }
    return null
}
const previsao = async (municipio: any, days?: DAYS) => {
    return prev((await cod(municipio)), days)
}
const Brasil = {
    cnpj, previsao, DAYS
}
export default Brasil;